export default function Loading() {
  return (
    <div className="h-100 py-4  w-100 d-flex flex-column justify-content-center align-items-center">
      <div className="spinner-border" role="status">
        <span className="sr-only"></span>
      </div>
      <p>Carregando...</p>
    </div>
  );
}
